import { TaxPayerService } from './../../../services/taxPayer.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationService } from 'src/app/services/application.service';
import { saveAs } from 'file-saver';
import { DivisionService } from 'src/app/services/division.service';
import { CategoryService } from 'src/app/services/category.service';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { MatDialog, MatGridTileHeaderCssMatStyler, MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { EntityService } from 'src/app/services/entity.service';
import { LocationService } from 'src/app/services/region.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { EditApplicationDialogComponent } from '../dialog/application-edit-dialog/edit-application-dialog.component';
@Component({
  selector: 'app-application-view',
  templateUrl: './application-view.component.html',
  styleUrls: ['./application-view.component.css']
})
export class ApplicationViewComponent implements OnInit {
  application: any;
  cities = []
  divisions = []
  backRoute: any
  tab: any
  durationInSeconds = 3;
  companyTypes: any[]
  entity: any
  additionalFields = []
  isRejectApplicationView = false;
  isOpenApplicationView = false;
  lan = 'en';
  photoUrl: SafeUrl = '';
  matchedTaxpayer: any = null;
  constructor(private applicationService: ApplicationService, public dialog: MatDialog, private route: ActivatedRoute,
    public translateService: TranslateService,
    private categoryService: CategoryService, private snackBar: MatSnackBar,
    private locationService: LocationService, private divisionService: DivisionService,
    private entityService: EntityService,
    private sanitizer: DomSanitizer,
    private taxPayerService: TaxPayerService,
    public router: Router) { }

  ngOnInit() {
    this.backRoute = this.route.snapshot.queryParamMap.get('backRoute')
    this.tab = this.route.snapshot.queryParamMap.get('tab')
    this.isRejectApplicationView = this.tab === 'reject';
    this.isOpenApplicationView = this.tab === 'approval' || this.isRejectApplicationView;
    this.lan = localStorage.getItem('default_lan') || 'en';
    this.applicationService.getResource('application', this.route.snapshot.paramMap.get('id')).subscribe(application => {
      this.application = application.data
      if (this.application.photo) {
        this.applicationService.getPhotoBlob(this.application.photo).subscribe(blob => {
          const objectUrl = URL.createObjectURL(blob);
          this.photoUrl = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
        });
      }
      this.applicationService.getResource('dictionary/category', this.application.type.id).subscribe(currentCategory => {


        for (var key in this.application.additionalFields) {
          var field = this.application.additionalFields[key]
          var strField = currentCategory.data.additionalFields.find(elem => elem.key === key)
          if (strField && ['text', 'number'].includes(strField.type)) {
            this.additionalFields.push({
              name: (strField.name && (strField.name[this.lan] || strField.name['en'])) || strField.key,
              value: field
            })
          }
        }
        if (this.application.taxpayerId) {
          this.entityService.getResource('taxpayer', this.application.taxpayerId).subscribe(
            entity => {
              this.entity = entity.data;
            }
          );
        } else if (!this.isRejectApplicationView) {
          this.findTaxpayerByPhone();
        }
        this.categoryService.getList('dictionary/category').subscribe(categories => {
          this.locationService.getList('dictionary/city').subscribe(cities => {
            this.divisionService.getList('dictionary/division').subscribe(divisions => {
              this.cities = cities.data.data
              this.divisions = divisions.data.data
              this.companyTypes = categories.data.data
            })
          })
        })
        this.divisionService.getSuggestedOffice(this.application.id).subscribe(office => {
          if (office.data && !this.application.division) {
            this.application.division = { id: office.data.id, name: office.data.name }
          }
        })
      })
    })
  }

  findTaxpayerByPhone() {
    const phone =
      this.application &&
      (
        this.application.telephone ||
        (this.application.additionalFields && this.application.additionalFields.telephone) ||
        (this.application.additionalFields && this.application.additionalFields.telephonetwo)
      );
  
    if (!phone) {
      this.matchedTaxpayer = null;
      return;
    }
  
    this.taxPayerService.getByTelephone(phone).subscribe((res: any) => {
      this.matchedTaxpayer = res && res.data ? res.data : null;
    });
  }

  public objectComparisonFunction = function (option, value): boolean {
    if (value)
      return option.id === value.id;
    return false;
  }

  openConfirmationDialog(application, action): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '600px',
      panelClass: 'custom-dialog-container',
      data: { obj: application, text: 'DIALOG.APPLICATION_' + action, action }
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if (!result) return;
  
      if (this.isOpenApplicationView) {
        if (action === 'APPROVE') {
          this.applicationService.changeApplicationStatus(
            'application/' + this.application.id + '/approve',
            { comment: this.application.comment, division: this.application.division }
          ).subscribe(res => {
            this.snackBar.open(this.translateService.instant('APPLICATIONS.' + action));
            this.application.status = 'active';
          });
        }
  
        if (action === 'REJECT') {
          this.applicationService.changeApplicationStatus(
            'application/' + this.application.id + '/reject',
            { comment: this.application.comment, division: this.application.division }
          ).subscribe(res => {
            this.snackBar.open(this.translateService.instant('APPLICATIONS.' + action));
            this.application.status = 'reject';
            this.router.navigate(['/applications'], {
              queryParams: { tab: 'reject' }
            });
          });
        }

        if (action === 'REOPEN') {
          this.applicationService.changeApplicationStatus(
            'application/' + this.application.id + '/reopen',
            { comment: this.application.comment, division: this.application.division }
          ).subscribe(res => {
            this.snackBar.open(this.translateService.instant('APPLICATIONS.' + action));
            this.application.status = 'approval';
            this.router.navigate(['/applications'], {
              queryParams: { tab: 'approval' }
            });
          });
        }

        if (action === 'DELETE') {
          this.applicationService.deleteApplication(this.application.id).subscribe(res => {
            this.snackBar.open(this.translateService.instant('APPLICATIONS.' + action));
            this.goBack();
          });
        }
  
        return;
      }
  
      if (result && action !== 'REJECT') {
        this.entityService.modifyResource('taxpayer', this.application.taxpayerId, 'activate').subscribe(res => {
          this.snackBar.open(this.translateService.instant('APPLICATIONS.' + action));
          this.entity.active = true;
        });
      }
    });
  }

  openApplicationDialog(application): void {
    const dialogRef = this.dialog.open(EditApplicationDialogComponent, {
      width: '850px',
      panelClass: 'custom-dialog-container',
      data: { application: application }
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.applicationService.getResource('application', this.route.snapshot.paramMap.get('id')).subscribe(applicationRes => {
          this.application = applicationRes.data;
        });
      }
    });
  }

  isReadonly() {
    return this.application.id && ['registration', 'validation'].includes(this.application.status)
  }

  goBack() {
    var qp = { queryParams: {} }
    if (this.tab) {
      qp.queryParams['tab'] = this.tab
    }
    if (JSON.stringify(qp.queryParams) === '{}')
      this.router.navigate(['/' + this.backRoute]);
    else
      this.router.navigate(['/' + this.backRoute], qp);
  }

  downloadFile(key) {
    this.applicationService.downloadFile(key).subscribe
      (data => {
        const blob = data;
        const file = new Blob([blob], {});
        const filename = key;
        saveAs(file, filename);
      });
  }

  getDisplayName() {
    if (!this.application) return '';
  
    if (this.application.name && this.application.name.trim() !== '') {
      return this.application.name;
    }
  
    return [this.application.firstname, this.application.lastname].filter(Boolean).join(' ');
  }
  
  getName(addF) {
    if (!addF) return '';
  
    var nameObj = addF.name || {};
    return nameObj[this.lan] || nameObj['en'] || addF.key || '';
  }
  
  getValue(addF) {
    if (!this.application || !addF) return '';
  
    const val = this.application.additionalFields
      ? this.application.additionalFields[addF.key]
      : '';
  
    if (val) {
      const raw = val.name || val;
      if (typeof raw === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(raw)) {
        return raw.split('T')[0];
      }
      return raw;
    }
  
    return '';
  }

  getMatchedTaxpayerDisplayName() {
    if (!this.matchedTaxpayer) return '';
  
    if (this.matchedTaxpayer.name && this.matchedTaxpayer.name.trim() !== '') {
      return this.matchedTaxpayer.name;
    }
  
    return [this.matchedTaxpayer.firstname, this.matchedTaxpayer.lastname].filter(Boolean).join(' ');
  }
  
  getMatchedTaxpayerValue(addF) {
  if (!this.matchedTaxpayer || !addF) return '';

  const val = this.matchedTaxpayer.additionalFields
    ? this.matchedTaxpayer.additionalFields[addF.key]
    : '';

  if (val) {
    const raw = val.name || val;
    if (typeof raw === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(raw)) {
      return raw.split('T')[0];
    }
    return raw;
  }

  return '';
}

  openMergeDialog(): void {
    if (!this.matchedTaxpayer) {
      this.snackBar.open(
        this.translateService.instant('APPLICATION-DIALOG.NO_TAXPAYER_FOUND'),
        '',
        { duration: 3000 }
      );
      return;
    }
  
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '600px',
      panelClass: 'custom-dialog-container',
      data: {
        obj: this.application,
        text: 'APPLICATION-DIALOG.APPLICATION_MERGE_CONFIRM',
        action: 'MERGE'
      }
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if (!result) return;
  
      this.applicationService.mergeApplication(this.application.id, this.matchedTaxpayer.id).subscribe(res => {
        this.snackBar.open(this.translateService.instant('APPLICATION-DIALOG.MERGED'));
        this.goBack();
      });
    });
  }
  
}
